import { atom } from "recoil";

export const reviewMenuModalState = atom({
  key: "reviewMenuModal",
  default: false,
});
